import { FC, useEffect, useState } from "react";
import { PatientInformationProps } from "./types";
import { formatPhoneNumber, formatSSN } from "src/helpers";



const PatientInformation: FC<PatientInformationProps> = ({ caseObject }): JSX.Element => {
  const [is_us_citizen, update_is_us_citizen] = useState<boolean>()
  const { patient_information } = caseObject;

  useEffect(() => {
    if (patient_information && patient_information.patient_attributes && patient_information.patient_attributes.length > 0) {
      const is_us_citizen = patient_information.patient_attributes.find((item) => item.name === "is_us_citizen")
      if (is_us_citizen) {
        if (is_us_citizen.value === "true") update_is_us_citizen(true)
        else update_is_us_citizen(false)
      }
    }
  }, [patient_information]);


  const getPrimaryPhone = (phoneNumbers?: { phone_type: string; phone_number: number }[]) => {
      if (!phoneNumbers || phoneNumbers.length === 0) return null;
    
      // Try to find a cell phone first
      const cellPhone = phoneNumbers.find(p => p.phone_type.toLowerCase() === "cell");
      if (cellPhone) return formatPhoneNumber(cellPhone.phone_number);
    
      // Otherwise, return the first available number
      return phoneNumbers[0]?.phone_number ? formatPhoneNumber(phoneNumbers[0].phone_number) : null;
    };
    
    const getPrimaryPhoneType = (phoneNumbers?: { phone_type: string; phone_number: number }[]) => {
      if (!phoneNumbers || phoneNumbers.length === 0) return null;
    
      const cellPhone = phoneNumbers.find(p => p.phone_type.toLowerCase() === "cell");
      if (cellPhone) return "Cell"; // Always show as "Cell"
    
      return phoneNumbers[0]?.phone_type
        ? phoneNumbers[0].phone_type.charAt(0).toUpperCase() + phoneNumbers[0].phone_type.slice(1) // Capitalize first letter
        : null;
    };

  return (
    <div className="card">
      <div className={`card-header ${caseObject.case_information.product === 'iovera°' ? 'iovera-theme' : 'zilretta-theme'}`}>
        <h4 className="m-0">Patient Information</h4>
      </div>

      <div className="card-body">
        <div className="row">

          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <label className="form-label">Title:</label>
              </div>
              <div className="col-6">
                <p>
                  {patient_information ? patient_information.patient_title : "N/A"}
                </p>
              </div>
            </div>
          </div>

          {/* <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <label className="form-label">Street:</label>
              </div>
              {typeof is_us_citizen === "boolean" && caseObject.case_information.product.toLowerCase().includes("zilr") ? (
                  <div className="row mb-3">
                      <div className="col-12 px-3">
                          <span className="fw-bold">US citizen or permanent resident?{' '}:</span>
                          <span className="ps-2">{is_us_citizen ? "Yes" : "No"}</span>
                      </div>
                  </div>
              ) : null}
          </div> */}


          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <label className="form-label">First Name:</label>
              </div>
              <div className="col-6">
                <p>
                  {patient_information ? patient_information.first_name : "N/A"}
                </p>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <label className="form-label">Suite:</label>
              </div>
              <div className="col-6">
                <p>
                  {patient_information && patient_information.address ? patient_information.address.suite : "N/A"}
                </p>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <label className="form-label">Last Name:</label>
              </div>
              <div className="col-6">
                <p>
                  {patient_information ? patient_information.last_name : "N/A"}
                </p>
              </div>
            </div>
          </div>


          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <label className="form-label">City:</label>
              </div>
              <div className="col-6">
                <p>
                  {patient_information && patient_information.address ? patient_information.address.city : "N/A"}
                </p>
              </div>
            </div>
          </div>


          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <label className="form-label">Middle Name:</label>
              </div>
              <div className="col-6">
                <p>
                  {patient_information ? patient_information.middle_name : "N/A"}
                </p>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <label className="form-label">State:</label>
              </div>
              <div className="col-6">
                <p>
                  {patient_information && patient_information.address ? patient_information.address.state : "N/A"}
                </p>
              </div>
            </div>
          </div>


          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <label className="form-label">Date of Birth:</label>
              </div>
              <div className="col-6">
                <p>
                  {patient_information ? patient_information.dob : "N/A"}
                </p>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <label className="form-label">Zip:</label>
              </div>
              <div className="col-6">
                <p>
                  {patient_information && patient_information.address ? patient_information.address.zip : "N/A"}
                </p>
              </div>
            </div>
          </div>
           <div className="col-12 col-md-6">
          <div className="row">
            <div className="col-6 text-end px-3">
              <label className="form-label">Gender:</label>
            </div>
            <div className="col-6">
              <p>
                {patient_information ? patient_information.gender : "N/A"}
              </p>
            </div>
          </div>
        </div>

         {patient_information && patient_information.patient_phone_numbers && patient_information.patient_phone_numbers.length > 0 
           && 
            
              <div className="col-12 col-md-6">
                <div className="row">
                  <div className="col-6 text-end px-3">
                    <label className="form-label">{ "Phone Number:"}</label>
                  </div>
                  <div className="col-6">
                    <p>{getPrimaryPhone(patient_information.patient_phone_numbers)}</p>
                  </div>
                </div>
              </div>
           
        
          
        }


        <div className="col-12 col-md-6">
          <div className="row">
            <div className="col-6 text-end px-3">
              <label className="form-label">SSN:</label>
            </div>
            <div className="col-6">
              <p>
                {patient_information ? formatSSN(patient_information.ssn) : "N/A"}
              </p>
            </div>
          </div>
        </div>

        <div className="col-12 col-md-6">
          <div className="row">
            <div className="col-6 text-end px-3">
              <label className="form-label">Type:</label>
            </div>
            <div className="col-6">
              <p>
               {getPrimaryPhoneType(patient_information.patient_phone_numbers)}
              </p>
            </div>
          </div>
        </div>
        </div>







        {/* {patient_information && patient_information.patient_phone_numbers && patient_information.patient_phone_numbers.length > 0 ?
          patient_information.patient_phone_numbers.map((item, index) => (
            <div className="row" key={index}>
              <div className="col-12 col-md-6">
                <div className="row">
                  <div className="col-6 text-end px-3">
                    <p>{item.phone_type ? `${item.phone_type} Phone Number:` : "Phone Number:"}</p>
                  </div>
                  <div className="col-6">
                    <p>{item && item.phone_number ? formatPhoneNumber(item.phone_number) : 'N/A'}</p>
                  </div>
                </div>
              </div>
            </div>
          ))
          : null
        } */}

        {typeof is_us_citizen === "boolean" ? (
          <div className="row mb-3">
            <div className="col-12 px-3">
              <span className="fw-bold">US citizen or permanent resident?{' '}:</span>
              <span className="ps-2">{is_us_citizen ? "Yes" : "No"}</span>
            </div>
          </div>
        ) : null}
      </div>
      </div>
  );
};

export default PatientInformation;
